<template>
    <button
        @click="handleCheckout"
        class="w-full bg-[var(--primary-400)] hover:bg-[var(--primary-700)] text-white font-semibold py-3 px-6 rounded-lg transition-colors"
    >
        {{ buttonText }}
    </button>

    <!-- Checkout Dialog -->
    <Teleport to="body">
        <div
            v-if="showDialog"
            class="fixed inset-0 bg-black/50 z-[60] flex items-center justify-center p-4"
            @click.self="closeDialog"
        >
            <div
                class="bg-white dark:bg-neutral-900 rounded-2xl w-full max-w-md p-8 shadow-xl"
                @click.stop
            >
                <h2 class="text-2xl font-bold text-neutral-900 dark:text-white mb-4 text-center">
                    {{ dialogTitle }}
                </h2>
                <div class="text-neutral-600 dark:text-neutral-400 mb-6 space-y-3">
                    <p>{{ dialogMessage }}</p>
                    <p>{{ dialogMessageSecond }}</p>
                </div>

                <form @submit.prevent="handleEmailSubmit" class="space-y-4">
                    <div>
                        <label class="block text-sm font-medium text-neutral-900 dark:text-white mb-2">
                            Email Address
                        </label>
                        <input
                            v-model="email"
                            type="email"
                            required
                            placeholder="your@email.com"
                            class="w-full px-4 py-2 border border-neutral-300 dark:border-neutral-600 rounded-lg bg-white dark:bg-neutral-800 text-neutral-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-[var(--primary-400)]"
                        />
                    </div>

                    <button
                        type="submit"
                        class="w-full bg-[var(--primary-400)] hover:bg-[var(--primary-700)] text-white font-semibold py-2 px-4 rounded-lg transition-colors"
                    >
                        Get My Discount
                    </button>
                </form>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { cartStore } from '../store/cart';
import { trackCheckout, trackEmailSubmit } from '../utils/analytics';

export default {
    name: 'CheckoutButton',
    props: {
        buttonText: {
            type: String,
            default: 'Checkout',
        },
        dialogTitle: {
            type: String,
            default: 'You Caught Us!',
        },
        dialogMessage: {
            type: String,
            default: 'Okay, you got us. These products aren\'t quite ready to ship just yet. But hey, we\'re not ones to leave you hanging!',
        },
        dialogMessageSecond: {
            type: String,
            default: 'Drop your email below and we\'ll send you a sweet 25% discount code to use once everything\'s polished and ready to go.',
        },
        discountCode: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showDialog: false,
            email: '',
        };
    },
    methods: {
        handleCheckout() {
            // Track checkout event
            const items = cartStore.state.items;
            const total = cartStore.getTotal();
            trackCheckout(items, total);

            // Prevent cart changes once checkout is initiated
            cartStore.initiateCheckout();

            // Mark cart as checked out (even without email yet)
            cartStore.saveCartToSheets(true, null);

            // Show dialog
            this.showDialog = true;
        },
        closeDialog() {
            this.showDialog = false;
            this.email = '';
        },
        async handleEmailSubmit() {
            // Track email submission event
            const items = cartStore.state.items;
            const total = cartStore.getTotal();
            trackEmailSubmit(items, total, this.email);
            
            // Save cart to Google Sheets with checkout status
            cartStore.saveCartToSheets(true, this.email);
            
            // Show success message
            if (window.app?.snackbar) {
                window.app.snackbar({ message: `Thanks! We'll send your 25% discount code to ${this.email}` });
            } else {
                alert(`Thanks! We'll send your 25% discount code to ${this.email}`);
            }
            
            // Close dialog and clear cart
            this.closeDialog();
            cartStore.clearCart();
            cartStore.closeCart();
        },
    },
};
</script>

<style scoped>
</style>

